import React, { Component } from 'react'
import cx from 'classnames'
import { Popover, Icon } from '@softwaredev_cegeka/stix-core'
import styles from './clampedText.module.scss'

class ClampedText extends Component {
    state = {
        textComponent: null,
    }
    summaryRef = React.createRef()
    popoverBtnRef = React.createRef()

    multiLineOverflows(el) {
        const containerHeight = el.current.clientHeight

        const text = el.current.children[0]
        return text.clientHeight > containerHeight
    }

    handlePopoverClose = () => {
        this.popoverBtnRef.current.click()
    }

    componentDidMount() {
        const { text, href } = this.props

        if (this.multiLineOverflows(this.summaryRef)) {
            this.setState({
                textComponent: (
                    <Popover
                        className={cx(styles.tooltip, 'clamped-text-tooltip')}
                        placement="top"
                        trigger="click"
                        content={
                            <>
                                <button
                                    className={cx(
                                        styles.closeBtn,
                                        styles.tooltipCloseBtn
                                    )}
                                    onClick={this.handlePopoverClose}
                                >
                                    <Icon icon="close" />
                                </button>
                                <span>{text}</span>
                            </>
                        }
                    >
                        <div className={styles.clampedText}>
                            <span className={styles.summary}>
                                {href ? (
                                    <a
                                        href={href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {text}
                                    </a>
                                ) : (
                                    text
                                )}
                            </span>

                            <button
                                ref={this.popoverBtnRef}
                                className={styles.more}
                                title={'Show all text'}
                            >
                                <span>...</span>
                            </button>
                        </div>
                    </Popover>
                ),
            })
        }
    }

    render() {
        const { text } = this.props

        return this.state.textComponent ? (
            this.state.textComponent
        ) : (
            <span ref={this.summaryRef} className={styles.summary}>
                <span>{text}</span>
            </span>
        )
    }
}

export default ClampedText
